import { useState } from 'react';

interface CoverArtProps {
  src: string | null;
  artist: string;
  title: string;
  eager?: boolean;
  className?: string;
}

export function CoverArt({ src, artist, title, eager = false, className = '' }: CoverArtProps) {
  const [failed, setFailed] = useState<string | null>(null);
  if (!src || failed === src) {
    return (
      <div className={`cover-art cover-fallback ${className}`} role="img" aria-label={`No cover available for ${title}`}>
        <span>{artist.slice(0, 1)}</span>
        <span>{title.slice(0, 1)}</span>
      </div>
    );
  }
  return (
    <img
      className={`cover-art ${className}`}
      src={src}
      alt={`${title} by ${artist} cover`}
      loading={eager ? 'eager' : 'lazy'}
      {...{ fetchpriority: eager ? 'high' : 'auto' }}
      width="640"
      height="640"
      onError={() => setFailed(src)}
    />
  );
}
